"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dangerouslyGetTheme = exports.getCurrentTheme = exports.getCurrentThemeKey = void 0;
const preferencesSelectors = __importStar(require("companion-app-components/flux/preferences/selectors"));
const store_1 = __importDefault(require("store"));
const reselect_1 = require("reselect");
const themeBase_1 = require("themes/themeBase");
const DEFAULT_THEME = 'light';
const getStoredThemeKey = () => {
    var _a;
    if (typeof window === 'undefined') {
        return null;
    }
    const themeKey = (_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem('theme');
    return themeKey === 'dark' || themeKey === DEFAULT_THEME ? themeKey : null;
};
const getDatasetThemeKey = (state) => (preferencesSelectors.getSharedPreferencesByPath(state, { group: 'user', path: ['webApp'] }) || {}).theme;
const getPreferencesLoadingState = (state) => preferencesSelectors.getLoadPendingState(state);
exports.getCurrentThemeKey = (0, reselect_1.createSelector)(getDatasetThemeKey, getPreferencesLoadingState, (themeKey, preferencesLoading) => {
    var _a;
    if (themeKey) {
        return themeKey;
    }
    if ((_a = preferencesLoading === null || preferencesLoading === void 0 ? void 0 : preferencesLoading.shared) === null || _a === void 0 ? void 0 : _a.dataset) {
        return getStoredThemeKey() || DEFAULT_THEME;
    }
    return DEFAULT_THEME;
});
exports.getCurrentTheme = (0, reselect_1.createSelector)(exports.getCurrentThemeKey, (themeKey) => (0, themeBase_1.getThemeByKey)(themeKey));
// don't use this method, unless you know what you are doing
const dangerouslyGetTheme = () => {
    const state = store_1.default.getState();
    const themeKey = state ? (0, exports.getCurrentThemeKey)(state) : DEFAULT_THEME;
    return (0, themeBase_1.getThemeByKey)(themeKey);
};
exports.dangerouslyGetTheme = dangerouslyGetTheme;
